import type { ReactElement } from 'react';
import styles from '../Fetch.module.css';
import type { Species } from '../types';

function DogIcon() {
  return (
    <svg
      className={styles.speciesIcon}
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M16 14V14.5M4.42 11.247C4.14013 12.3277 3.999 13.4396 4 14.556C4 18.728 7.582 21 12 21C16.418 21 20 18.728 20 14.556C19.995 13.4351 19.829 12.3207 19.507 11.247M8 14V14.5M8.5 8.5C8.116 9.55 7.417 10.528 6.156 11C4.225 11.722 2.58 10.703 2.5 10C2.387 9.006 3.677 3.47 6.5 3C8.423 2.679 10.151 3.845 10.151 5.235C11.4158 4.91378 12.7425 4.92826 14 5.277C14 3.887 15.844 2.679 17.767 3C20.59 3.47 21.88 9.006 21.767 10C21.687 10.703 20.042 11.722 18.111 11C16.85 10.528 16.256 9.55 15.872 8.5M11.25 16.25H12.75L12 17L11.25 16.25Z" />
    </svg>
  );
}

function CatIcon() {
  return (
    <svg
      className={styles.speciesIcon}
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M8 14V14.5M16 14V14.5M12 5C12.67 5 13.35 5.09 14 5.26C15.78 3.26 19.03 2.42 20.42 3C21.82 3.58 20 10 20 10C20.57 11.07 21 12.24 21 13.44C21 17.9 16.97 21 12 21C7.03 21 3 18 3 13.44C3 12.19 3.5 11.04 4 10C4 10 2.11 3.58 3.5 3C4.89 2.42 8.22 3.23 10 5.23C10.656 5.07911 11.3268 5.00196 12 5ZM11.25 16.25H12.75L12 17L11.25 16.25Z" />
    </svg>
  );
}

function CheckIcon() {
  return (
    <svg
      className={styles.speciesCheck}
      width={20}
      height={20}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M20 6 9 17l-5-5" />
    </svg>
  );
}

const OPTIONS: { value: Species; label: string; Icon: () => ReactElement }[] = [
  { value: 'DOG', label: 'Dog', Icon: DogIcon },
  { value: 'CAT', label: 'Cat', Icon: CatIcon },
];

interface FetchSpeciesToggleProps {
  value: Species;
  onChange: (species: Species) => void;
}

export function FetchSpeciesToggle({
  value,
  onChange,
}: FetchSpeciesToggleProps) {
  return (
    <div className={styles.speciesRow} role="radiogroup" aria-label="Pet type">
      {OPTIONS.map(({ value: optionValue, label, Icon }) => {
        const selected = value === optionValue;
        return (
          <button
            key={optionValue}
            type="button"
            role="radio"
            aria-checked={selected}
            className={
              selected
                ? `${styles.speciesOption} ${styles.speciesOptionSelected}`
                : styles.speciesOption
            }
            onClick={() => onChange(optionValue)}
          >
            <span className={styles.speciesOptionMain}>
              <Icon />
              <span className={styles.speciesLabel}>{label}</span>
            </span>
            {selected && <CheckIcon />}
          </button>
        );
      })}
    </div>
  );
}
